<div class="sidebar-wrapper">
  <painel-usuarios class="side-details"
                   ng-if="sidebar === 'users'"></painel-usuarios>
  <painel-maquinas-wrapper class="side-details tabbed-side-details"
                           ng-if="sidebar === 'usosMaquinas'"></painel-maquinas-wrapper>
  <resumo-produtividade class="side-details"
                        ng-if="sidebar === 'produtividadeSummary'"
                        data="data"></resumo-produtividade>
  <resumo-stand class="side-details"
                ng-if="sidebar === 'standSummary'"
                data="data"></resumo-stand>
  <historico-aplicacoes class="side-details tabbed-side-details"
                        ng-if="sidebar === 'applications'"
                        data="data"></historico-aplicacoes>
  <historico-recomendacoes class="side-details tabbed-side-details"
                           ng-if="sidebar === 'recommendations'"></historico-recomendacoes>
  <painel-edicao-recomendacao class="side-details"
                              ng-if="sidebar === 'addRecommendation'"></painel-edicao-recomendacao>
  <painel-edicao-correcao class="side-details"
                          ng-if="sidebar === 'addRecommendationCorrecao'"></painel-edicao-correcao>
  <painel-edicao-adubacao class="side-details"
                          ng-if="sidebar === 'addRecommendationAdubacao'"></painel-edicao-adubacao>
  <historico-tarefas class="side-details"
                     ng-if="sidebar === 'tasks'"></historico-tarefas>
  <painel-add-task class="side-details"
                   ng-if="sidebar === 'addTask'"
                   data="data"></painel-add-task>
  <historico-demarcacao class="side-details"
                        ng-if="sidebar === 'historyDrawPolygons'"></historico-demarcacao>
  <painel-edicao-demarcacao class="side-details"
                            ng-if="sidebar === 'drawPolygon'"
                            data="data"></painel-edicao-demarcacao>
  <historico-mapas class="side-details"
                   ng-if="sidebar === 'historyMapListing'"></historico-mapas>
  <painel-criar-mapa class="side-details"
                     ng-if="sidebar === 'painelCriarMapa'"></painel-criar-mapa>
  <resumo-ocorrencias class="side-details"
                      ng-if="sidebar === 'occurrencesSummary'"></resumo-ocorrencias>
  <edicao-auditoria-aplicacao class="side-details"
                              ng-if="sidebar === 'edicaoAuditoriaAplicacao'"
                              data="data"></edicao-auditoria-aplicacao>
  <historico-afericoes class="side-details tabbed-side-details"
                       ng-if="sidebar === 'historicoAfericoes'"></historico-afericoes>
  <weather-forecast-panel class="side-details"
                          ng-if="sidebar === 'weatherForecast'"></weather-forecast-panel>
  <painel-edicao-aplicacao class="side-details"
                           ng-if="sidebar === 'editApplication'"
                           data="data"></painel-edicao-aplicacao>
</div>
